export const VACANCY_PATH = "/vacancies/:id";
